/**
 * @file VirtualizedList atom — low-level virtualized list primitive.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/VirtualizedList
 */
export { VirtualizedList } from "@/components/ui/virtualized-list";
